import { SUB_MENU_DEFAULT_KEYS } from '../SubMenu.constants'
import { SubMenuItem } from '../SubMenuItem'

import * as styles from './SubMenuList.module.css'

function SubMenuList(props) {
  const {
    apiKeys = SUB_MENU_DEFAULT_KEYS,
    className = styles.SubMenuList,
    counts,
    isActive,
    items,
  } = props

  return (
    <div className={className}>
      {items.map(item => (
        <SubMenuItem
          apiKeys={apiKeys}
          count={counts?.[item[apiKeys.value]]}
          item={item}
          key={item[apiKeys.value]}
          selected={isActive(item)}
          onClick={props.onClickItem}
        />
      ))}
    </div>
  )
}

export default SubMenuList
